import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getUpdatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { PromotionConfigureFormContainer } from '../components/PromotionConfigureForm/PromotionConfigureFormContainer';
import { messages } from '../messages';
import { useGetIsOrderAheadEnabledForPromotion } from '../hooks/useGetIsOrderAheadEnabledForPromotion';

export const PromotionUpdatePageContainer: React.FC = () => {
  const { id: campaignId = '', promotionId = '' } = useParams<{
    id: string;
    promotionId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getIsOrderAheadEnabled = useGetIsOrderAheadEnabledForPromotion();
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: promotionId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={promotionId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Promotion}
      ConfigureFormContainer={PromotionConfigureFormContainer}
      getIsOrderAheadEnabled={getIsOrderAheadEnabled}
    />
  );
};
